// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"34636e93","191":"5df49db2","669":"44ac4705"}[chunkId] + ".chunk.js";
};